import React, { useState, useEffect } from 'react';
import { auth, db } from './firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import './Profile.css';

function Profile({ user, onProfileComplete }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Load existing profile data when component mounts
    loadProfile();
  }, [user]);

  const loadProfile = async () => {
    try {
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (userDoc.exists()) {
  const data = userDoc.data();
  setName(data.name || '');
  setPhone(data.phone || '');
  setIsEditing(true); // User is editing existing profile
}
    } catch (err) {
      console.error('Error loading profile:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveProfile = async (e) => {
    e.preventDefault();
    setError('');
    setSaving(true);

    try {
      // Save user profile to Firestore
      const userRef = doc(db, 'users', user.uid);
const userDoc = await getDoc(userRef);

const profileData = {
  name: name,
  phone: phone,
  email: user.email,
  updatedAt: new Date().toISOString()
};

// Only set createdAt if this is a new profile
if (!userDoc.exists()) {
  profileData.createdAt = new Date().toISOString();
}

await setDoc(userRef, profileData, { merge: true });

      console.log('Profile saved successfully!');
      onProfileComplete();
    } catch (err) {
      setError(err.message);
      console.error('Error saving profile:', err);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="profile-container">
        <div className="profile-box">
          <h2>Loading...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <div className="profile-box">
       <h1>{isEditing ? 'Edit Your Profile' : 'Complete Your Profile'}</h1>
        <p className="subtitle">Tell us a bit about yourself to get started</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSaveProfile}>
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              placeholder="Enter your full name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
  <label>Phone Number <span style={{ color: '#999', fontWeight: 'normal', fontSize: '0.85em' }}>(optional)</span></label>
  <input
    type="tel"
    placeholder="(555) 123-4567"
    value={phone}
    onChange={(e) => setPhone(e.target.value)}
  />
</div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={user.email}
              disabled
              className="disabled-input"
            />
            <small>This will be your login and cannot be changed</small>
          </div>

          <button type="submit" className="save-btn" disabled={saving}>
            {saving ? 'Saving...' : (isEditing ? 'Update Profile' : 'Save Profile & Continue')}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Profile;